import React from 'react';
import classes from './landingCooperation.module.css';

const features = [
  {
    title: 'أفضل المعلمين المختارين بعناية فائقة',
    icon: '/assets/icons/cooperation/advantages/mocktest-icon.svg',

    id: 1,
  },
  {
    title: 'توفر جميع المواد و المراحل للتعلم العام و الجامعي',
    icon: '/assets/icons/cooperation/advantages/microcourses-icon.svg',

    id: 2,
  },
  {
    title: 'تقارير دورية عن أداء الأبناء من المعلمين',
    icon: '/assets/icons/cooperation/features/certificate-icon.svg',
    id: 3,
  },
  {
    title:
      'الضمان الذهبي: في حال لم تناسب الحصة الاولى فلا تدفع، وفي حال لم يناسبك المعلم سيتم تبدليه فوري',
    icon: '/assets/icons/cooperation/features/cup-icon.svg',

    id: 4,
  },
];

const advantages = (discount) => [
  {
    title: 'حصة',
    description: ' حصة أولى مجانية لابنائك',
    icon: '/assets/icons/cooperation/features/desktop-icon.svg',
    id: 1,
  },
  {
    title: 'خصم خاص',
    description: `خصم خاص بقيمة ${discount}% على الباقات الشهرية`,
    icon: '/assets/icons/cooperation/features/money-icon.svg',

    id: 2,
  },
  {
    title: 'مرشد تعليمي',
    description: 'مرشد تعليمي مخصص لابنكم يساعدكم على تحقيق أفضل النتائج',
    icon: '/assets/icons/cooperation/advantages/onlinecourses-icon.svg',
    id: 3,
  },
];
const FeaturesSection = ({ name, discount, cooperation }) => {
  return (
    <>
      <section className={classes['cooperations-section']}></section>
      <section className={classes['features-section']}>
        <h2>فهيم في الإعلام</h2>
        <div className={classes['features-img-container']}>
          <img src="/assets/imgs/cooperations.png" alt="cooperations" />
        </div>
        <h2 className="mt-4">لماذا أدرس أبنائي في منصة فهيم؟</h2>
        <div className={classes['features-container']}>
          {features.map((feature) => (
            <div className={classes['feature']} key={feature.id}>
              <img src={feature.icon} alt={feature.title} />
              <p>{feature.title}</p>
            </div>
          ))}
        </div>
      </section>
      {cooperation && (
        <section className={classes['advantages-section']}>
          <h3>
            بالتعاون مع {name.toUpperCase()} ستحصل على التالي عندما تسجل أبنائك
            في فهيم
          </h3>
          <div className={classes['advantages-container']}>
            {advantages(discount).map((advantage) => (
              <div className={classes['advantage']} key={advantage.id}>
                <div className={classes['advantage-card-wrapper']}>
                  <div className={classes['advantage-card-details']}>
                    <h3>{advantage.title}</h3>
                    <p>{advantage.description}</p>
                  </div>
                  <img src={advantage.icon} alt={advantage.title} />
                </div>
              </div>
            ))}
          </div>
        </section>
      )}
    </>
  );
};

export default FeaturesSection;
